<template>
  <section class="form-card">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'FormCard',
}
</script>

<style scoped>
.form-card {
  position: relative;
  margin-top: 28px;
  padding: 30px 14px 18px;
  border: 1.5px solid #c7cfb8;
  border-radius: 22px;
  background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
  box-shadow: 0 22px 40px rgba(68, 85, 38, 0.12),
    0 2px 0 rgba(255, 255, 255, 0.42) inset;
}
</style>
